<app-side-menu>
  <div class="template-versions-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h1 class="page-title">
                <i class="fas fa-layer-group me-3"></i>
                Versões do Template #{{ templateId }}
              </h1>
              <p class="page-subtitle">Histórico de versões publicadas e seus arquivos</p>
            </div>
            <div>
              <button class="btn btn-outline-secondary" (click)="goBack()">
                <i class="fas fa-arrow-left me-2"></i>Voltar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Conteúdo Principal -->
    <div class="row">
      <div class="col-12">
        <div class="template-versions-card">
          <div *ngIf="isLoading">Carregando...</div>

          <!-- Estado vazio -->
          <div *ngIf="!isLoading && (!versions || versions.length === 0)" class="empty-state">
            <i class="fas fa-layer-group"></i>
            <h3>Nenhuma versão encontrada</h3>
            <p>As versões do template serão exibidas aqui quando disponíveis.</p>
          </div>

          <!-- Tabela -->
          <div class="mb-3 d-flex align-items-center gap-2">
            <div>
              <label class="form-label">Selecionar nova versão (.docx)</label>
              <input type="file" accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document" (change)="onFileSelected($event)" [disabled]="isUploading" />
            </div>
            <div class="ms-3">
              <button type="button" class="btn btn-sm btn-success" (click)="saveNewVersion()" [disabled]="!selectedFile || isUploading">
                {{ isUploading ? 'Enviando...' : 'Salvar nova versão' }}
              </button>
            </div>
          </div>

          <!-- Tabela Genérica -->
          <div *ngIf="!isLoading && versions && versions.length > 0">
            <app-table
              [title]="'Lista de Versões'"
              [data]="versions"
              [columns]="columns"
              [loading]="isLoading"
              [showSearch]="true"
              [searchPlaceholder]="'Buscar por versão, status ou arquivo...'"
              [clickable]="false"
              [actions]="actions"
              [useDropdownMenu]="true"
              (actionClick)="onActionClick($event)">
            </app-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>


